const CurrentUser = `
  query {
    currentUser {
      id
      email
      role
    }
  }
`

module.exports = {
  CurrentUser,
}
  